import { trpc } from '@/shared/api';
import { usePresignedImageUpload } from '@/shared/lib';

/** 기획전 대표 이미지 업로드 — 발급(exhibitions.presignImageUpload) → S3 직접 PUT. */
export const useExhibitionImageUpload = () => {
  const presignMutation = trpc.productManagement.exhibitions.presignImageUpload.useMutation();

  return usePresignedImageUpload((contentType) => presignMutation.mutateAsync({ contentType }));
};
